import Page from '~/pages/page';
import FormValidator from "../../helpers/form-validator";

export default class HomepageIndex extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();

        this._action = 'form.php';
        this._is_process = false;

    }

    init() {
        this.dom.btnSend = document.querySelector('.js-send');
        this.dom.successSend = document.querySelector('.success-send');
        this.dom.error = document.querySelector('.error-form');
        this.dom.input = document.querySelectorAll('.js-input');
        this.dom.inputMessage = document.querySelector('#message');

        this._Validator = new FormValidator({
                'inputs' : this.dom.input,
                'parent' : false
        });
    }

    bind() {
        this.dom.btnSend.addEventListener('click', this.process.bind(this));
    }

    process(e) {
        if( this._is_process == false ) {
            this._is_process = true;
            e.preventDefault();

            grecaptcha.ready(() => {
                grecaptcha.execute('6LemAfUZAAAAAI68EPd9IDmApVd483fLsi7O4_pz').then((token) => {
                    let data = new FormData();

                    if( this._Validator.isValid() )
                    {

                        let formInputs = this._Validator.getData();


                        for(let item in formInputs)
                        {
                            data.append(item, formInputs[item]);
                        }

                        data.append('message', this.dom.inputMessage.value );
                        data.append('recaptcha_response', token.toString() );

                        this._request(data);
                    }
                    this._is_process = false;
                });
            });
        }
    }
    _request(data) {
        const xhr = new XMLHttpRequest();
        xhr.open('POST',  this._action, true);
        xhr.onreadystatechange = function () {
            if(xhr.readyState === 4 && xhr.status === 200) {
                if (xhr.response) {
                    let response = JSON.parse(xhr.response);

                    if (response.errors){
                        this._error();
                    }
                } else {
                    this._success();
                }
                this.is_process = false;
            }
            this._is_process = false;
        }.bind(this);
        xhr.send(data);
    }

    _success() {
        this.dom.successSend.style.display = "block";
        this.cleanErrors();

        setTimeout(() =>{
            this.dom.successSend.style.display = "none";
        }, 5000);

    }
    _error() {
        this.dom.error.style.display = "block";
        setTimeout(() =>{
            this.dom.error.style.display = "none";
        }, 5000);
    };
    cleanErrors() {
        for( var i = 0, j = this.dom.input.length; i < j; i++ )
        {
            this.dom.input[i].classList.remove('success');
            this.dom.input[i].value = '';
        }
        this.dom.inputMessage.classList.remove('success');
        this.dom.inputMessage.value = '';
    }

    // init() {
    //     super.init();
    // }


    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}
